/*=========================================================================================
  File Name: moduleNews.js
  Description: News Module
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import state from './moduleNewsState.js'
import mutations from './moduleNewsMutations.js'
import actions from './moduleNewsActions.js'
import getters from './moduleNewsGetters.js'

export default {
	namespaced: true,
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters
}
